import { useState, useEffect, FC } from "react";
import axios from "axios";
import {
  StarryBackground,
  NebulaEffect,
  ContentContainer,
  HeaderContainer,
  TitleContainer,
  BackButton,
  ContentArea,
} from "./styled";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import * as locales from "@mui/material/locale";
import { getDateTime } from "../lib/utils";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import keycloak from "../../keycloak";

const rmiacURL = process.env.REACT_APP_RMIAC as string;

const postReportsGetStatementsURL =
  process.env.REACT_APP_API_URL + "api/Reports/GetStatements";

const title = "Отчет";

const TabsArray = [
  {
    value: "all",
    label: "Все справки",
  },
  {
    value: "MedicalGroupForTrains",
    label:
      "Медицинское заключение о принадлежности несовершеннолетнего к медицинской группе для занятий физической культурой",
  },
  {
    value: "Form291U",
    label: "Справка об отсутствии контактов с инфекционными больными",
  },
  {
    value: "Form070U",
    label: "Справка для получения путевки на санаторно-курортное лечение",
  },
  {
    value: "processed",
    label: "Архив",
  },
];

const date = new Date();
date.setDate(date.getDate() - 14);

const Report: FC<{ handleClose: () => void }> = ({ handleClose }) => {
  const [data, setData] = useState<any | undefined>(undefined);
  const [isDataLoading, setisDataLoading] = useState<boolean>(false);
  const [certificateKind, setCertificateKind] = useState<string>(
    TabsArray[0].value,
  );
  const [resolvingDateFrom, setResolvingDateFrom] = useState(
    date.toISOString().split("T")[0],
  );
  const [resolvingDateTo, setResolvingDateTo] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [receivingDateFrom, setReceivingDateFrom] = useState(
    date.toISOString().split("T")[0],
  );
  const [receivingDateTo, setReceivingDateTo] = useState(
    new Date().toISOString().split("T")[0],
  );

  const theme = useTheme();
  const themeWithLocale = createTheme(theme, locales["ruRU"]);

  useEffect(() => {
    document.title = title;

    if (
      resolvingDateFrom &&
      resolvingDateTo &&
      receivingDateFrom &&
      receivingDateTo
    ) {
      setisDataLoading(true);

      axios
        .post(
          postReportsGetStatementsURL,
          {
            certificateKindSystemName: certificateKind,
            commonStatus: 0,
            resolvingDateFrom: new Date(resolvingDateFrom).toISOString(),
            resolvingDateTo: new Date(resolvingDateTo).toISOString(),
            receivingDateFrom: new Date(receivingDateFrom).toISOString(),
            receivingDateTo: new Date(receivingDateTo).toISOString(),
          },
          {
            headers: {
              Authorization: `Bearer ${keycloak.token}`,
            },
          },
        )
        .then((data) => {
          setData(data.data);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            alert("Ошибка авторизации");
          } else {
            alert("Не удалось загрузить список сертификатов, " + err);
          }
        })
        .finally(() => setisDataLoading(false));
    }
  }, [
    certificateKind,
    resolvingDateFrom,
    resolvingDateTo,
    receivingDateFrom,
    receivingDateTo,
  ]);

  return (
    <StarryBackground>
      <NebulaEffect />
      <ThemeProvider theme={themeWithLocale}>
        <ContentContainer>
          <HeaderContainer>
            <BackButton
              onClick={() => handleClose()}
              startIcon={<ArrowBackIcon />}
            >
              Назад
            </BackButton>
            <TitleContainer>
              <Typography
                color="white"
                variant="h1"
                sx={{
                  fontSize: "48px",
                  fontWeight: "bold",
                  textShadow: `
                                        0 0 10px rgba(59, 130, 246, 0.5),
                                        0 0 20px rgba(59, 130, 246, 0.3),
                                        0 0 30px rgba(59, 130, 246, 0.2)
                                    `,
                  animation: "titleGlow 3s ease-in-out infinite",
                  "@keyframes titleGlow": {
                    "0%, 100%": {
                      textShadow: `
                                                0 0 10px rgba(59, 130, 246, 0.5),
                                                0 0 20px rgba(59, 130, 246, 0.3),
                                                0 0 30px rgba(59, 130, 246, 0.2)
                                            `,
                    },
                    "50%": {
                      textShadow: `
                                                0 0 15px rgba(59, 130, 246, 0.8),
                                                0 0 25px rgba(59, 130, 246, 0.5),
                                                0 0 35px rgba(59, 130, 246, 0.3)
                                            `,
                    },
                  },
                }}
              >
                К
                <IconButton
                  href={rmiacURL}
                  target="_blank"
                  sx={{
                    padding: 0,
                    marginBottom: "10px",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "transparent",
                      transform: "scale(1.1)",
                      cursor: "pointer",
                    },
                  }}
                >
                  <img
                    src="/logo-cosmos.svg"
                    alt="custom icon"
                    style={{ width: 50, height: 50 }}
                  />
                </IconButton>
                СМОС
              </Typography>
            </TitleContainer>
          </HeaderContainer>
          <ContentArea sx={{ mb: 2 }}>
            <Box
              display="flex"
              flexDirection="column"
              gap={1}
              p={1}
              mb={1}
              sx={{ background: "lightgray", borderRadius: 1 }}
            >
              <Select label="Выберите причину отказа" value={certificateKind}>
                {TabsArray.map(({ value, label }) => (
                  <MenuItem
                    key={value}
                    value={value}
                    onClick={() => setCertificateKind(value)}
                  >
                    {label}
                  </MenuItem>
                ))}
              </Select>
              <Box display="flex" gap={1} alignItems="center">
                {/* <TextField
                  label="С какой даты обработано"
                  value={resolvingDateFrom}
                  type="date"
                  onChange={(e) => setResolvingDateFrom(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  color="primary"
                  sx={{ width: "180px" }}
                />
                <TextField
                  label="По какую дату обработано"
                  value={resolvingDateTo}
                  type="date"
                  onChange={(e) => setResolvingDateTo(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  color="primary"
                  sx={{ width: "180px" }}
                /> */}
                <TextField
                  label="С какой даты получено"
                  value={receivingDateFrom}
                  type="date"
                  onChange={(e) => setReceivingDateFrom(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  color="primary"
                  sx={{ width: "180px" }}
                />
                <TextField
                  label="По какую дату получено"
                  value={receivingDateTo}
                  type="date"
                  onChange={(e) => setReceivingDateTo(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  color="primary"
                  sx={{ width: "180px" }}
                />
                <Typography ml="auto">
                  Справок получено: {data?.length || 0}
                </Typography>
              </Box>
            </Box>
            {isDataLoading ? (
              <CircularProgress />
            ) : (
              <TableBody>
                {/* @ts-ignore */}
                {data?.map((elem, index) => (
                  <TableRow
                    key={index}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {elem.certificateKind.name}
                    </TableCell>
                    <TableCell align="right">{elem.status.name}</TableCell>
                    <TableCell align="right">
                      {getDateTime(new Date(elem.receivingDate))}
                    </TableCell>
                    <TableCell align="right">
                      {getDateTime(new Date(elem.resolvingDate))}
                    </TableCell>

                    <TableCell>
                      {elem.rejectionReason && elem.rejectionReason.name}
                    </TableCell>

                    <TableCell sx={{ whiteSpace: "nowrap" }}>
                      {elem.rtmisLpuName && elem.rtmisLpuName}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </ContentArea>
        </ContentContainer>
      </ThemeProvider>
    </StarryBackground>
  );
};

export default Report;
